export const BookOpenIcon = ({ className }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2804_74476)">
        <path
          d="M8.5 5.5C8.5 4.96957 8.71071 4.46086 9.08579 4.08579C9.46086 3.71071 9.96957 3.5 10.5 3.5H14.5C14.6326 3.5 14.7598 3.55268 14.8536 3.64645C14.9473 3.74021 15 3.86739 15 4V12C15 12.1326 14.9473 12.2598 14.8536 12.3536C14.7598 12.4473 14.6326 12.5 14.5 12.5H10.5C9.96957 12.5 9.46086 12.7107 9.08579 13.0858C8.71071 13.4609 8.5 13.9696 8.5 14.5"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 12C2 12.1326 2.05268 12.2598 2.14645 12.3536C2.24021 12.4473 2.36739 12.5 2.5 12.5H6.5C7.03043 12.5 7.53914 12.7107 7.91421 13.0858C8.28929 13.4609 8.5 13.9696 8.5 14.5V5.5C8.5 4.96957 8.28929 4.46086 7.91421 4.08579C7.53914 3.71071 7.03043 3.5 6.5 3.5H2.5C2.36739 3.5 2.24021 3.55268 2.14645 3.64645C2.05268 3.74021 2 3.86739 2 4V12Z"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 6H13"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 8H13"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 10H13"
          stroke="#282828"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2804_74476">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
